import { Component, inject } from '@angular/core';
import { BottomSheetControlsComponent } from '../../bottom-sheet-controls/bottom-sheet-controls.component';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'upsell-bottom-sheet',
  standalone: true,
  imports: [BottomSheetControlsComponent, MatIconModule],
  templateUrl: './upsell-bottom-sheet.component.html',
  styleUrl: './upsell-bottom-sheet.component.scss',
})
export class UpsellBottomSheetComponent {
  public _bottomSheetRef =
    inject<MatBottomSheetRef<UpsellBottomSheetComponent>>(MatBottomSheetRef);
}
